export default "__VITE_ASSET__DGuE0wRe__"